<template>
  <!-- <div :class="['home', {'content-box': unit_type_id === 20001}]">
  <ul class="tabs" v-if="unit_type_id === 20001">-->
  <div class="content-box home">
    <ul class="tabs">
      <router-link tag="li" :to="{name: 'reportStudy'}">
        <a href="javascript:;">学习数据</a>
      </router-link>
      <router-link tag="li" :to="{name: 'reportGrowthFile'}">
        <a href="javascript:;">成长档案</a>
      </router-link>
    </ul>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  computed: {
    unit_type_id () {
      return this.$store.state.user.unit_type_id
    }
  }
}
</script>>

<style lang="stylus" scoped>
.content-box {
  height: 100%;
  padding-top: 44px;
}

.is-web {
  .tabs {
    top: 63px;
  }
}

.tabs {
  display: flex;
  position: fixed;
  box-shadow: 0px 2px 8px 0px rgba(101, 113, 117, 0.1);
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  background-color: white;

  li {
    flex-grow: 1;
    text-align: center;
    font-size: 15px;
  }

  a {
    color: #333;
    line-height: 44px;
  }

  .link-active {
    a {
      font-weight: bold;
      underline(20px);
    }
  }
}

.gray {
  color: #ccc !important;

  span {
    font-size: 8px;
  }
}
</style>
